import React from "react";

import Image from "next/image";

import FigureImage from "public/images/enerflo-reporting-image.png";

import Heading from "components/heading";

import HeroSection from "../../hero-section";

const title = "AI-Powered Reporting Suite";

const MainHero = () => (
  <HeroSection title={title} className="flex-col md:flex-row">
    <HeroSection.Content className="md:w-1/2">
      <HeroSection.Header className="md:items-start">
        <Heading tag="h1">{title}</Heading>
      </HeroSection.Header>
      <HeroSection.Description>
        Built on the Domo Business Intelligence Platform. Better Data. Better Insights. Better Results.
      </HeroSection.Description>
    </HeroSection.Content>

    <figure className="p-3 w-full xs:w-4/5 sm:w-3/4 md:w-1/2">
      <Image
        src={FigureImage}
        alt="Enerflo AI-Powered Solar Reporting & Analytics Software."
        layout="responsive"
        quality={100}
        placeholder="blur"
        loading="eager"
        priority
        className="crispImage"
        sizes="(min-width: 768px) 50vw, 100vw"
      />
    </figure>
  </HeroSection>
);

export default MainHero;
